import $ from 'jquery';
import Swiper from 'swiper/bundle';
import imagesLoaded from 'imagesloaded';

imagesLoaded.makeJQueryPlugin($);

// eslint-disable-next-line no-undef
const object = gralObject;

const initializeBlock = function ($block) {
    const offersWrapper = $block.find('.offers-block__offers');
    const offersAhead = offersWrapper.attr('data-ahead');
    const data = {
        action: 'gral_offers',
        nonce: object.nonce,
        offersAhead: offersAhead,
    };

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data,
        success: (res) => {
            if (res.success) {
                setTimeout(() => {
                    offersWrapper.html(res.data.content);

                    $block.imagesLoaded(function () {
                        new Swiper($block.find('.offers-block__slider')[0], {
                            slidesPerView: 1.2,
                            spaceBetween: 30,
                            scrollbar: {
                                el: '.offers-block__scrollbar',
                                draggable: true,
                            },
                            breakpoints: {
                                768: {
                                    slidesPerView: 2,
                                },
                                992: {
                                    slidesPerView: 3,
                                },
                            },
                        });
                    });
                }, 1000);
            }
        },
    });
};

$('.offers-block').each(function () {
    initializeBlock($(this));
});

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=gral-offers',
        initializeBlock
    );
}
